import type { TributeItem } from 'tributejs';
import Tribute from 'tributejs';

interface TributeObjectCompletion {
  key: string;
  value: string;
}

const textCompletionConfig = {
  selectTemplate: (item: TributeItem<TributeObjectCompletion>) => item.original.value,
  menuItemTemplate: (item: TributeItem<TributeObjectCompletion>) => item.string,
  menuContainer: document.body,
  lookup: 'key',
  fillAttr: 'value',
  replaceTextSuffix: '',
  autocompleteMode: true,
  menuItemLimit: 5,
};

const TextCompletionTribute = (values: TributeObjectCompletion[]) => new Tribute({
  values,
  ...textCompletionConfig,
});

const initializeCreatureClassificationCompletion = () => {
  const creatureClassificationFields = [].slice.call(document.querySelectorAll('.creature-classification'));

  if (creatureClassificationFields.length > 0) {
    const rawClassifications = window.nattwenny.creatureClassifications;
    const values = rawClassifications.map((classification: string) => ({
      key: classification,
      value: classification,
    }));

    TextCompletionTribute(values).attach(creatureClassificationFields[0]);
  }
};

const initializePlaceCategoryCompletion = () => {
  const placeCategoryFields = [].slice.call(document.querySelectorAll('.place-category'));

  if (placeCategoryFields.length > 0) {
    const rawCategories = window.nattwenny.placeCategories;
    const values = rawCategories.map((category: string) => ({ key: category, value: category }));

    TextCompletionTribute(values).attach(placeCategoryFields[0]);
  }
};

const NwTextCompletion = {
  initialize: () => {
    initializeCreatureClassificationCompletion();
    initializePlaceCategoryCompletion();
  },
};

export default NwTextCompletion;
